const viewmateDeluxeFAQs = [
  {
    id: 1,
    question:
      'I have ViewMate Deluxe, am I required to upgrade to ViewMate Essentials?',
    answer:
      'You are not require to upgrade to ViewMate Essentials. Your ViewMate Deluxe license is perpetual so it will remain fully functional without interruption; however, no further versions will be released. We will continue to provide support by phone or email until your maintenance contract expires.',
  },
  {
    id: 2,
    question:
      'I would like to upgrade to ViewMate Essentials but my ViewMate Deluxe maintenance contract has expired, do I have to pay to upgrade?',
    answer:
      'As a valued ViewMate Deluxe customer with expired maintenance contract you qualify for a 50% discount on your first subscription license.',
  },
  {
    id: 3,
    question:
      'I would like to upgrade to ViewMate Essentials and my ViewMate Deluxe maintenance contract is still active, do I have to pay to upgrade?',
    answer:
      `
      <p>As a valued ViewMate Deluxe customer with an active maintenance contract, you are entitled to a 50% discount on your first subscription license, along with an additional prorated discount based on your renewal date. The table below provides an example for a single, computer-locked license.</p>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Renewal Date</th>
            <th>50% Discount</th>
            <th>Prorated Maintenance Discount</th>
            <th>Total Price</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>August, 2025</td><td>$97.50</td><td>$56.00</td><td>$41.50</td></tr>
          <tr><td>July, 2025</td><td>$97.50</td><td>$51.00</td><td>$46.50</td></tr>
          <tr><td>June, 2025</td><td>$97.50</td><td>$46.00</td><td>$51.50</td></tr>
          <tr><td>May, 2025</td><td>$97.50</td><td>$41.00</td><td>$56.50</td></tr>
          <tr><td>April, 2025</td><td>$97.50</td><td>$36.00</td><td>$61.50</td></tr>
          <tr><td>March, 2025</td><td>$97.50</td><td>$31.00</td><td>$66.50</td></tr>
          <tr><td>February, 2025</td><td>$97.50</td><td>$26.00</td><td>$71.50</td></tr>
          <tr><td>January, 2025</td><td>$97.50</td><td>$21.00</td><td>$76.50</td></tr>
          <tr><td>December, 2024</td><td>$97.50</td><td>$16.00</td><td>$81.50</td></tr>
          <tr><td>November, 2024</td><td>$97.50</td><td>$11.00</td><td>$86.50</td></tr>
          <tr><td>October, 2024</td><td>$97.50</td><td>$6.00</td><td>$91.50</td></tr>
          <tr><td>September, 2024</td><td>$97.50</td><td>$1.00</td><td>$97.50</td></tr>
        </tbody>
      </table>
    `
  },
  {
    id: 4,
    question:
      'I recently purchased ViewMate Deluxe, can I get a free upgrade to ViewMate Essentials?',
    answer: `
      <p>As a valued ViewMate Deluxe customer, you are entitled to a discount on your first subscription license, along with an additional prorated discount based on your purchase date. The table below illustrates an example for a single computer-locked license.</p>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Purchase Date</th>
            <th>Base Price</th>
            <th>50% Discount</th>
            <th>Prorated Discount</th>
            <th>Final Price</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>August, 2025</td><td>$195.00</td><td>$97.50</td><td>$97.50</td><td>$0.00</td></tr>
          <tr><td>July, 2025</td><td>$195.00</td><td>$97.50</td><td>$89.38</td><td>$8.12</td></tr>
          <tr><td>June, 2025</td><td>$195.00</td><td>$97.50</td><td>$81.25</td><td>$16.25</td></tr>
          <tr><td>May, 2025</td><td>$195.00</td><td>$97.50</td><td>$73.13</td><td>$24.38</td></tr>
          <tr><td>April, 2025</td><td>$195.00</td><td>$97.50</td><td>$65.00</td><td>$32.50</td></tr>
          <tr><td>March, 2025</td><td>$195.00</td><td>$97.50</td><td>$56.88</td><td>$40.63</td></tr>
          <tr><td>February, 2025</td><td>$195.00</td><td>$97.50</td><td>$48.75</td><td>$48.75</td></tr>
          <tr><td>January, 2025</td><td>$195.00</td><td>$97.50</td><td>$40.63</td><td>$56.88</td></tr>
          <tr><td>December, 2024</td><td>$195.00</td><td>$97.50</td><td>$32.50</td><td>$65.00</td></tr>
          <tr><td>November, 2024</td><td>$195.00</td><td>$97.50</td><td>$24.38</td><td>$73.13</td></tr>
          <tr><td>October, 2024</td><td>$195.00</td><td>$97.50</td><td>$16.25</td><td>$81.25</td></tr>
          <tr><td>September, 2024</td><td>$195.00</td><td>$97.50</td><td>$8.13</td><td>$89.38</td></tr>
          <tr><td>August, 2024</td><td>$195.00</td><td>$97.50</td><td>$0.00</td><td>$97.50</td></tr>
        </tbody>
      </table>
    `,
  },
  {
    id: 5,
    question:
      'If I install ViewMate Essentials on my computer, can I no longer access ViewMate Deluxe?',
    answer:
      'Both ViewMate Deluxe and ViewMate Essentials can be installed on the same computer without any issue.',
  },
  {
    id: 6,
    question:
      'Is ViewMate Essentials available as a perpetual license?',
    answer:
      'ViewMate Essentials is only available as a yearly subscription license which includes full customer support and continuous software updates.',
  },
  {
    id: 7,
    question:
      'Will I get technical support and updates if I purchased ViewMate Deluxe a few months ago?',
    answer:
      'Your license of ViewMate Deluxe is perpetual so it will remain fully functional without interruption; however, no further versions will be released. We will continue to provide support by phone or email until your maintenance contract expires.',
  },
  {
    id: 8,
    question:
      'Will I have access to new ViewMate Deluxe updates if I detect any bugs?',
    answer:
      'ViewMate Deluxe is a proven, reliable CAM software that has served thousands of customers for many years. In the event you detect a bug while your maintenance remains active, we will gladly provide a complimentary upgrade to ViewMate Essentials.',
  },
  {
    id: 9,
    question:
      'Can I upgrade my ViewMate Deluxe to ViewMate Pro?',
    answer:
      'Yes, you can upgrade to ViewMate Pro or ViewMate Essentials.',
  },
];

const viewmateProFAQs = [
  {
    id: 1,
    question:
      'I have ViewMate Pro, am I required to upgrade to ViewMate Professional?',
    answer:
      'As a valued ViewMate Pro customer with an expired maintenance contract, you qualify for a 50% discount on your annual subscription license.',
  },
  {
    id: 2,
    question:
      'I would like to upgrade to ViewMate Professional but my ViewMate Pro maintenance contract has expired, do I have to pay to upgrade?',
    answer:
      'As a valued ViewMate Pro customer with expired maintenance contract you qualify for a 50% discount on your first subscription license.',
  },
  {
    id: 3,
    question:
      'I would like to upgrade to ViewMate Professional and my ViewMate Pro maintenance contract is still active, do I have to pay to upgrade?',
    answer:
      'As a valued ViewMate Pro customer, you are eligible for a complimentary upgrade that will remain active throughout the remainder of your maintenance period.',
  },
  {
    id: 4,
    question:
      'If I install ViewMate Professional on my computer, can I no longer access ViewMate Pro?',
    answer:
      'Both ViewMate Pro and ViewMate Professional can be installed on the same computer without any issue.',
  },
  {
    id: 5,
    question:
      'Is ViewMate Professional available as a perpetual license?',
    answer:
      'ViewMate Professional is offered exclusively as an annual subscription, which includes full customer support and ongoing software updates.',
  },
  {
    id: 6,
    question:
      'Will I get technical support and updates if I purchased ViewMate Pro a few months ago?',
    answer:
      'Your license of ViewMate Pro is perpetual so it will remain fully functional without interruption; however, no further versions will be released. We will continue to provide support by phone or email until your maintenance contract expires.',
  },
  {
    id: 7,
    question:
      'Will I have access to new ViewMate Professional updates if I detect any bugs?',
    answer:
      'ViewMate Pro is a proven and reliable CAM solution that has served thousands of customers for many years. If you encounter a bug while your maintenance is active, we will be happy to provide a complimentary upgrade to ViewMate Professional.',
  },
  {
    id: 8,
    question:
      'What is the difference between ViewMate Pro and ViewMate Professional?',
    answer:
      `<p><span class="font-heavy">ViewMate Pro</span> and ViewMate Professional are both CAM tools, but they differ significantly in scope and capability:</p>
      <p>ViewMate Pro is an established CAM editor designed for PCB data preparation, editing, and manufacturing tasks. It includes features such as Gerber and drill editing, DXF import/export, layer comparison, stencil shape generation, and Smart DFM checks, making it a strong tool for designers and engineers preparing files for fabrication and assembly.</p>
      <p><span class="font-heavy">ViewMate Professional</span> represents a major step up by combining the full capabilities of CAMMaster, our premier CAM software with PCB Navigator, the advanced inspection and data-intelligence tool from ViewMate Essentials. CAMMaster adds robust scripting and automation tools alongside advanced CAM functions, and PCB Navigator enhances visualization, search and reporting.</p>`,
  },
];

export const faqData = {
  'viewmate-deluxe': viewmateDeluxeFAQs,
  'viewmate-pro': viewmateProFAQs,
};